import React, { useState, useEffect } from "react";
import { useStateValue } from "../../../../State";

import Moment from "moment";

import Languages from "../../../../translations";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import LockIcon from "@mui/icons-material/Lock";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  nobottomline: {
    borderBottom: "none",
    color: "black",
    backgroundColor: "#ffffff",
    flex: "0 0 100%",
  },
  fixedbottom: {
    float: "right !important",
    fontSize: "x-large",
    position: "fixed",
    fontWeight: "bold",
    color: "#D500F9",
    right: "0",
    bottom: "0",
    zIndex: "1040 !important",
  },
  displaynone: {
    display: "none",
  },
}));

const ChildSupportParentsHeard = (props) => {
  const classes = useStyles();

  const { Form, callback, Lockingcallback, ParentId, closeView } = props;

  const { state /*, actions*/ } = useStateValue();

  const MainGeneralPart = state.leops.GeneralPart;

  const Table3 = state.leops.Table3;
  console.log("STATE", state);
  console.log("TABLE3", Table3);
  const SubModel = Table3.SupportPlanModel ?? null;
  const Table3GeneralPart = Table3 === null ? null : Table3.GeneralPart;
  const GeneralPart =
    Table3GeneralPart === null ? null : Table3GeneralPart[Form];
  if (!SubModel || !GeneralPart) {
    return null;
  }

  const isParent1 = ParentId === GeneralPart.Parent1Id;
  const isParent2 = ParentId === GeneralPart.Parent2Id;

  const [expanded, setExpanded] = useState(false);
  const [FormLocked, setFormLocked] = useState(SubModel.Locked);
  const [Parent1Checked, setParent1Checked] = useState(SubModel.HearedParent1);
  const [Parent2Checked, setParent2Checked] = useState(SubModel.HearedParent2);
  const [SendReq, setSendReq] = useState(false);
  const [parent1ApprovalText, setParent1ApprovalText] = useState(
    SubModel.HearedParent1Approval ?? "",
  );
  const [parent2ApprovalText, setParent2ApprovalText] = useState(
    SubModel.HearedParent2Approval ?? "",
  );

  //console.log("ConsultationChildAndGuardian. MOUNT. \n FormLocked: ", FormLocked, "\n SubModel: ", SubModel);

  //useEffect(() => {
  /*console.log("ConsultationChildAndGuardian. useEffect. ",
                "\n Parent1Checked: ", Parent1Checked,
                "\n Parent2Checked: ", Parent2Checked, 
                "\n GeneralPart.Parent2Name: ",GeneralPart.Parent2Name,
                "\n FormLocked: ", FormLocked,
                "\n SendReq: ", SendReq);*/

  //if (SendReq)
  //{
  //setFormLocked(Parent1Checked && ( Parent2Checked || GeneralPart.Parent2Name === null) ? true : false);

  //kumpi ja mihin suuntaan ruksi muutettu, montako parenttia => serveri päättelee meneekö lukkoon
  //Lockingcallback(SendReq, SubModel.HearedParent1Editable ? Parent1Checked : Parent2Checked, GeneralPart.Parent2Name === null ? 1 : 2);
  //setSendReq(false);
  //}

  //},[SubModel, Parent1Checked, Parent2Checked, SendReq]);

  useEffect(() => {
    //console.log("Table1. useEffect. Close view");
    setExpanded(false);
  }, [closeView]);

  useEffect(() => {
    if (!SubModel) return;

    setParent1Checked(SubModel.HearedParent1);
    setParent2Checked(SubModel.HearedParent2);
    setParent1ApprovalText(SubModel.HearedParent1Approval ?? "");
    setParent2ApprovalText(SubModel.HearedParent2Approval ?? "");
    setFormLocked(SubModel.Locked);
  }, [SubModel]);

  const toggleExpanded = () => {
    setExpanded(!expanded);
    callback("CCG");
  };

  const toogleCheckBox = (CheckBox) => {
    //console.log("ConsultationChildAndGuardian. toogleCheckBox: ",CheckBox);

    if (CheckBox === "1") {
      setParent1Checked(!Parent1Checked);
    } else {
      setParent2Checked(!Parent2Checked);
    }
    setSendReq(CheckBox);
  };

  return (
    <Accordion
      className="painikkeet"
      style={{ backgroundColor: "#4377BA" /*, color: "black"*/ }}
      //disabled = {item.Saved === "" ? true: false}
      expanded={expanded}
      onChange={() => toggleExpanded()}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel3a-content"
        id="test_Leops_SupportTableCCG"
      >
        <Typography className="heading">
          {" "}
          {Languages.ParentalHearing}
          {FormLocked ? (
            <LockIcon style={{ color: "#D500F9" }} fontSize="large"></LockIcon>
          ) : null}
        </Typography>
      </AccordionSummary>
      <div className={classes.nobottomline}>
        <AccordionDetails>
          <h5>{Languages.ParentalHearing2}</h5>
        </AccordionDetails>

        <AccordionDetails>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.nobottomline} align="left">
                  {Languages.guardian + " 1"}
                </TableCell>
                <TableCell
                  className={classes.nobottomline}
                  align="left"
                  style={{ paddingLeft: "20px" }}
                >
                  {Languages.guardian + " 2"}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell className={classes.nobottomline} align="left">
                  <input
                    type="checkbox"
                    style={{ width: "20px", height: "20px" }}
                    checked={Parent1Checked}
                    disabled={
                      !isParent1 ||
                      !SubModel.HearedParent1Editable ||
                      MainGeneralPart.FormLocked ||
                      SubModel.HearedParent1
                    }
                    onChange={() => setParent1Checked(!Parent1Checked)}
                  />
                  {"  " + GeneralPart.Parent1Name}
                </TableCell>

                <TableCell
                  className={classes.nobottomline}
                  align="left"
                  style={{ paddingLeft: "20px" }}
                >
                  {GeneralPart.Parent2Name && (
                    <input
                      type="checkbox"
                      style={{ width: "20px", height: "20px" }}
                      checked={Parent2Checked}
                      disabled={
                        !isParent2 ||
                        !SubModel.HearedParent2Editable ||
                        MainGeneralPart.FormLocked ||
                        SubModel.HearedParent2
                      }
                      onChange={() => setParent2Checked(!Parent2Checked)}
                    />
                  )}
                  {"  " + (GeneralPart.Parent2Name ?? "")}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className={classes.nobottomline}
                  padding="none"
                  align="left"
                >
                  <textarea
                    value={parent1ApprovalText}
                    onChange={(e) => setParent1ApprovalText(e.target.value)}
                    disabled={
                      !isParent1 ||
                      !SubModel.HearedParent1Editable ||
                      MainGeneralPart.FormLocked ||
                      SubModel.HearedParent1
                    }
                    rows={3}
                    style={{ width: "100%", resize: "vertical" }}
                  />
                </TableCell>

                <TableCell
                  className={classes.nobottomline}
                  align="left"
                  style={{ paddingLeft: "20px" }}
                >
                  {GeneralPart.Parent2Name && (
                    <textarea
                      value={parent2ApprovalText}
                      onChange={(e) => setParent2ApprovalText(e.target.value)}
                      disabled={
                        !isParent2 ||
                        !SubModel.HearedParent2Editable ||
                        MainGeneralPart.FormLocked ||
                        SubModel.HearedParent2
                      }
                      rows={3}
                      style={{ width: "100%", resize: "vertical" }}
                    />
                  )}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell className={classes.nobottomline} align="left">
                  {isParent1 && Parent1Checked && (
                    <button
                      hidden={
                        !isParent1 ||
                        !SubModel.HearedParent1Editable ||
                        MainGeneralPart.FormLocked ||
                        SubModel.HearedParent1
                      }
                      onClick={() =>
                        Lockingcallback(
                          "1",
                          Parent1Checked,
                          parent1ApprovalText,
                          GeneralPart.Parent2Name ? 2 : 1,
                        )
                      }
                    >
                      {Languages.SaveHearing}
                    </button>
                  )}
                </TableCell>

                <TableCell
                  className={classes.nobottomline}
                  align="left"
                  style={{ paddingLeft: "20px" }}
                >
                  {isParent2 && Parent2Checked && (
                    <button
                      hidden={
                        !isParent2 ||
                        !SubModel.HearedParent2Editable ||
                        MainGeneralPart.FormLocked ||
                        SubModel.HearedParent2
                      }
                      onClick={() =>
                        Lockingcallback(
                          "2",
                          Parent2Checked,
                          parent2ApprovalText,
                          2,
                        )
                      }
                    >
                      {Languages.SaveHearing}
                    </button>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </AccordionDetails>
      </div>
    </Accordion>
  );
};

export default ChildSupportParentsHeard;
